<div class="flex flex-col gap-2">
	<div class="flex items-center justify-between">
		<p class="font-bold text-xl">Policy types</p>
		<app-button
			*ngIf="!disabled"
			size="small"
			[icon]="ICON.ADD"
			(click)="addPolicy()"
			[testHook]="testHooks.AddPolicyButton"
			>Add policy</app-button
		>
	</div>
	<div *ngIf="!disabled">
		<p>
			Add owner and/or lender policies
			<span class="text-orange-500">(required)</span>
		</p>
	</div>
	<div
		class="w-full"
		[ngClass]="{ 'lg:grid lg:grid-cols-2 lg:gap-x-2': type === 'compact' }"
	>
		<ng-container *ngIf="policies$ | async as policies">
			<app-container *ngFor="let policy of policies" class="mb-2">
				<div class="flex items-center justify-between">
					<p class="text-lg font-bold">
						{{ titleInsurancePolicyTypeString[policy.type] || policy.type }}
					</p>
					<div class="flex gap-2 items-center" *ngIf="!disabled">
						<app-icon
							[icon]="ICON.EDIT"
							class="cursor-pointer hover:bg-gray-200 rounded-md p-1 w-8 flex justify-center items-center"
							(click)="addPolicy(policy)"
							[testHook]="testHooks.AddPolicyIcon"
						></app-icon>
						<app-icon
							[icon]="ICON.DELETE"
							class="cursor-pointer hover:bg-gray-200 rounded-md p-1 w-8 flex justify-center items-center"
							(click)="deletePolicy(policy.id)"
							[testHook]="testHooks.DeletePolicyIcon"
						></app-icon>
					</div>
				</div>
				<div class="flex items-center gap-2 text-xs mb-4 text-grey">
					<p>{{ policy.number }}</p>
					<p *ngIf="policy.priority">
						MORTGAGE PRIORITY: {{ policy.priority }}
					</p>
				</div>
				<div class="flex gap-2 justify-start">
					<p class="text-grey">Insured amount</p>
					<p *ngIf="policy.insuredAmount">
						{{ policy.insuredAmount | centsToDollars }}
					</p>
					<p *ngIf="!policy.insuredAmount">See policy document(s)</p>
				</div>
				<div class="flex gap-2 justify-start">
					<p class="text-grey">Name(s) of insured</p>
					<p>{{ policy.name }}</p>
				</div>
			</app-container>
		</ng-container>
	</div>
</div>
